var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVxFieldIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VxField_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 176.7 49.2",
    style: {
      enableBackground: "new 0 0 176.7 49.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.vxfield-st0{fill:#C4161C;}\r\n\t.vxfield-st1{fill:#B11116;}\r\n\t.vxfield-st2{fill:#800507;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st0",
    d: "M44.3,32.6c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c-0.1-0.9-0.4-1.8-0.9-2.6l-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3 L32.6,10.7c-0.2,0.6-0.5,1.2-0.8,1.8l-7.5,13l6.5,11.1c1.2,2.1,3.4,3.4,5.6,3.6H37c3.5,0,6.5-2.5,7.1-5.8c0,0,0,0,0,0 c0-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C44.3,32.8,44.3,32.7,44.3,32.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st1",
    d: "M15.9,10.9l6.3,10.9l6.3-10.9c1.9-3.2,0.9-7.4-2-9.5c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.3 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.1-0.5-0.2 c0,0-0.1,0-0.1,0c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.1,0-0.1,0 c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1C18.7,0.9,18.6,1,18.5,1 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0-0.1,0.1-0.2,0.1C14.9,3.6,14,7.7,15.9,10.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st2",
    d: "M0,32.6c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c0.1-0.9,0.4-1.8,0.9-2.6l0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3 l10.4-18.1c0.2,0.6,0.5,1.2,0.8,1.8l7.5,13l-6.5,11.1c-1.2,2.1-3.4,3.4-5.6,3.6H7.3c-3.5,0-6.5-2.5-7.1-5.8c0,0,0,0,0,0 c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C0,32.8,0,32.7,0,32.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st2",
    d: "M58.9,10.7L64,26.3L69,10.7h5.4l-7.2,20.7h-6.5l-7.2-20.7H58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st2",
    d: "M88.9,31.4L84.5,25l-3.8,6.4H75l6.6-10.7l-6.8-10h5.9L85,17l3.7-6.2h5.7l-6.5,10.4l7,10.3H88.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st2",
    d: "M116.1,10.7v4h-8.5v4.5h6.6v3.8h-6.6v8.4h-5V10.7H116.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st2",
    d: "M123.7,10.7v20.7h-5V10.7H123.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st2",
    d: "M132.2,14.7v4.3h7v3.8h-7v4.6h7.9v4h-12.9V10.7h12.9v4H132.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st2",
    d: "M147.9,27.6h6.7v3.8h-11.7V10.7h5V27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "vxfield-st2",
    d: "M174.3,26.5c-0.9,1.6-2.1,2.8-3.8,3.7c-1.6,0.9-3.6,1.3-5.8,1.3h-7.8V10.7h7.8c2.2,0,4.2,0.4,5.8,1.3 c1.6,0.9,2.9,2.1,3.7,3.6c0.9,1.6,1.3,3.4,1.3,5.4C175.6,23.1,175.1,24.9,174.3,26.5z M168.9,25.4c1.1-1,1.6-2.5,1.6-4.4 s-0.5-3.3-1.6-4.4c-1.1-1-2.6-1.6-4.6-1.6h-2.4V27h2.4C166.3,27,167.8,26.4,168.9,25.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVxFieldIcon);
export default __webpack_public_path__ + "static/media/VxFieldIcon.b470fbc5.svg";
export { ForwardRef as ReactComponent };